let routes = [
  {
    path: '/achat-service-reference',
    component: () => import('../views/AchatServiceReference.vue'),
    props: true
  },
  {
    path: '/achat-service-reference/:step',
    component: () => import('../views/AchatServiceReference.vue'),
    props: true
  }
]

export default routes;